var map = {
	"./autosaveCard.json": "IEcy",
	"./autosaveDescription.json": "plGI",
	"./bellCount.json": "CGGu",
	"./cardNotifications.json": "i1+E",
	"./confirmDuringSignup.json": "BSp5",
	"./madLibs.json": "tMYW",
	"./npsSurvey.json": "bGHy",
	"./personalizedInvite.json": "26uh",
	"./pluginNewCalendar.json": "ooRz",
	"./powerUpSuggestions.json": "eBu/",
	"./showApiErrors.json": "qfIv",
	"./simplifiedView.json": "ySAo",
	"./subscribeToWatchOrFollow.json": "i5iS",
	"./superHomeTeamCards.json": "XB8T",
	"./tacoHearts.json": "V3Ia"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2m93";


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config nonrecursive \.json$
// module id = 2m93
// module chunks = 1